export const REDIRECTION_BASIC_DELAY = 3000;
